import { InjectionToken, Component, Input, Injectable, Inject, ɵɵdefineInjectable, ɵɵinject, NgModule } from '@angular/core';
import { createAction, props, createSelector, createReducer, on, select, Store, StoreModule } from '@ngrx/store';
import { createEffect, ofType, Actions, EffectsModule } from '@ngrx/effects';
import { InjectedTextFeautureModule, NamedString, InjectedTextProvider } from '@modeso/modeso-lib-core-fe';
import { CommonModule } from '@angular/common';
import Debug from 'debug';
import { createEntityAdapter } from '@ngrx/entity';
import { of, EMPTY } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { mergeMap, retry, map, catchError, tap } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/order.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function OrderConfig() { }
if (false) {
    /** @type {?} */
    OrderConfig.prototype.serviceId;
}
/** @type {?} */
const OrderConfigService = new InjectionToken('Config');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/order-title/order-title.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class OrderTitleComponent {
    constructor() { }
}
OrderTitleComponent.decorators = [
    { type: Component, args: [{
                selector: 'lidl-lib-order-fe-title',
                template: "<div class=\"order-title\">\r\n  <h1>{{titleText}}</h1>\r\n</div>\r\n",
                styles: [".order-title{margin-bottom:41px;font-weight:700}.order-title h1{font-size:42px}"]
            }] }
];
/** @nocollapse */
OrderTitleComponent.ctorParameters = () => [];
OrderTitleComponent.propDecorators = {
    titleText: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    OrderTitleComponent.prototype.titleText;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/short-email-details/short-email-details.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ShortEmailDetailsComponent {
    constructor() {
    }
    /**
     * add tow days for the current date.
     * @return {?}
     */
    ngOnInit() {
    }
}
ShortEmailDetailsComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-short-email-details',
                template: "<div class=\"order-details\">\r\n  <p>{{ \"modeso_order_short-email-details_you-will-receive-email\" | injectedText | async }}</p>\r\n  <div class=\"order-id-date\">\r\n    {{ \"modeso_order_short-email-details_order-referece-caption\" | injectedText | async }} <span>{{orderId}}</span> |\r\n    {{ \"modeso_order_short-email-details_order-delviery-date-caption\" | injectedText | async }}\r\n    <span>{{deliveryDate}}</span>\r\n  </div>\r\n</div>\r\n",
                styles: [".order-details{margin-bottom:40px}.order-details p{margin-bottom:20px}.order-details span{font-weight:700}.order-details .order-id-date{font-size:15px;background-color:#3bd072;padding:15px;color:#fff}"]
            }] }
];
/** @nocollapse */
ShortEmailDetailsComponent.ctorParameters = () => [];
ShortEmailDetailsComponent.propDecorators = {
    deliveryDate: [{ type: Input }],
    orderId: [{ type: Input }],
    language: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ShortEmailDetailsComponent.prototype.deliveryDate;
    /** @type {?} */
    ShortEmailDetailsComponent.prototype.orderId;
    /** @type {?} */
    ShortEmailDetailsComponent.prototype.language;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/order-sub-title/order-sub-title.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class OrderSubTitleComponent {
    constructor() { }
}
OrderSubTitleComponent.decorators = [
    { type: Component, args: [{
                selector: 'lidl-lib-order-fe-sub-title',
                template: "<div class=\"order-sub-title\">\r\n  <p>{{subTitleText}}</p>\r\n</div>\r\n",
                styles: [".order-sub-title{margin-bottom:15px;font-weight:700}.order-sub-title p{font-size:23px}"]
            }] }
];
/** @nocollapse */
OrderSubTitleComponent.ctorParameters = () => [];
OrderSubTitleComponent.propDecorators = {
    subTitleText: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    OrderSubTitleComponent.prototype.subTitleText;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/payment.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Payment Option Model that return
 */
class PaymentModel {
    constructor() { }
    /**
     * @param {?} payment
     * @return {?}
     */
    setPaymentModel(payment) {
        this.paymentId = payment.paymentId;
        this.paymentName = payment.paymentName;
    }
    /**
     * @return {?}
     */
    validatePaymentModel() {
        return (this.paymentId && this.paymentName) ? true : false;
    }
}
if (false) {
    /** @type {?} */
    PaymentModel.prototype.paymentId;
    /** @type {?} */
    PaymentModel.prototype.paymentName;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/address.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Address {
    constructor() { }
    /**
     * @param {?} address
     * @return {?}
     */
    setAddressModel(address) {
        this.zipCode = address.zipCode;
        this.city = address.city;
        this.country = address.country;
        this.firstName = address.firstName;
        this.lastName = address.lastName;
        this.email = address.email;
        this.street = address.street;
        this.streetNumber = address.streetNumber;
        this.company = address.company;
        this.addressSupplement = address.addressSupplement;
    }
    /**
     * @return {?}
     */
    validateAddressModel() {
        return (this.zipCode && this.city &&
            this.country && this.firstName &&
            this.lastName && this.email &&
            this.street && this.streetNumber) ? true : false;
    }
}
if (false) {
    /** @type {?} */
    Address.prototype.zipCode;
    /** @type {?} */
    Address.prototype.city;
    /** @type {?} */
    Address.prototype.country;
    /** @type {?} */
    Address.prototype.firstName;
    /** @type {?} */
    Address.prototype.lastName;
    /** @type {?} */
    Address.prototype.email;
    /** @type {?} */
    Address.prototype.street;
    /** @type {?} */
    Address.prototype.streetNumber;
    /** @type {?} */
    Address.prototype.company;
    /** @type {?} */
    Address.prototype.addressSupplement;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/product.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Product {
    constructor() { }
    /**
     * @param {?} product
     * @return {?}
     */
    setProductModel(product) {
        this.title = product.title;
        this.description = product.description;
        this.productId = product.productId;
        this.price = product.price;
        this.amount = product.amount;
        this.packagePrice = product.packagePrice;
        this.isPackagingSelected = product.isPackagingSelected;
        this.image = product.image;
        this.category = product.category;
        this.ean = product.ean;
    }
    /**
     * @return {?}
     */
    validateProductModel() {
        return (this.title && this.amount && this.description &&
            this.productId && this.price && this.packagePrice &&
            this.category && this.ean);
    }
}
if (false) {
    /** @type {?} */
    Product.prototype.title;
    /** @type {?} */
    Product.prototype.description;
    /** @type {?} */
    Product.prototype.image;
    /** @type {?} */
    Product.prototype.productId;
    /** @type {?} */
    Product.prototype.price;
    /** @type {?} */
    Product.prototype.amount;
    /** @type {?} */
    Product.prototype.packagePrice;
    /** @type {?} */
    Product.prototype.isPackagingSelected;
    /** @type {?} */
    Product.prototype.category;
    /** @type {?} */
    Product.prototype.ean;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/DeliveryOption.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DeliveryOption {
    constructor() { }
    /**
     * @param {?} deliveryOption
     * @return {?}
     */
    setDeliveryOptionModel(deliveryOption) {
        this.name = deliveryOption.name;
        this.description = deliveryOption.description;
        this.price = deliveryOption.price;
        this.deliveryDate = deliveryOption.deliveryDate;
    }
    /**
     * @return {?}
     */
    validateDeliveryOptionModel() {
        return (this.name && this.description && this.price && this.deliveryDate) ? true : false;
    }
}
if (false) {
    /** @type {?} */
    DeliveryOption.prototype.name;
    /** @type {?} */
    DeliveryOption.prototype.description;
    /** @type {?} */
    DeliveryOption.prototype.price;
    /** @type {?} */
    DeliveryOption.prototype.deliveryDate;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/cart.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug = Debug('modeso:lidl-lib-order-fe:Cart');
class Cart {
    constructor() { }
    /**
     * @param {?} cart
     * @return {?}
     */
    setCartModel(cart) {
        this._id = cart._id;
        this.products = [];
        cart.products.forEach((/**
         * @param {?} product
         * @return {?}
         */
        product => {
            /** @type {?} */
            const productObj = new Product();
            productObj.setProductModel(product);
            this.products.push(productObj);
        }));
        if (cart.deliveryOption) {
            this.deliveryOption = new DeliveryOption();
            this.deliveryOption.setDeliveryOptionModel(cart.deliveryOption);
        }
    }
    /**
     * @return {?}
     */
    validateCartModel() {
        this.products.forEach((/**
         * @param {?} product
         * @return {?}
         */
        product => {
            if (!product.validateProductModel()) {
                return false;
            }
        }));
        debug('cart deliveryOption:');
        debug(this.deliveryOption);
        //TODO validate delivery option in order
        //return (this.deliveryOption && this.deliveryOption.validateDeliveryOptionModel() && this.products.length >= 1) ? true : false ;
        return (this.products.length >= 1) ? true : false;
    }
}
if (false) {
    /** @type {?} */
    Cart.prototype._id;
    /** @type {?} */
    Cart.prototype.products;
    /** @type {?} */
    Cart.prototype.deliveryOption;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/order.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$1 = Debug('modeso:lidl-lib-order-fe:Order');
class Order {
    constructor() { }
    /**
     * @param {?} payment
     * @param {?} cart
     * @param {?} address
     * @param {?} deliveryOption
     * @return {?}
     */
    setOrderModel(payment, cart, address, deliveryOption) {
        this.userId = localStorage.getItem('UID');
        this.deliveryOption = deliveryOption;
        /** @type {?} */
        const paymentObj = new PaymentModel();
        if (payment) {
            paymentObj.setPaymentModel(payment);
            this.paymentMethod = paymentObj;
        }
        /** @type {?} */
        const cartObj = new Cart();
        cartObj.setCartModel(cart);
        this.cart = cartObj;
        this.totalPrice = cart.totalPrice;
        this.address = [];
        address.forEach((/**
         * @param {?} add
         * @return {?}
         */
        add => {
            /** @type {?} */
            const addressObj = new Address();
            if (add) {
                addressObj.setAddressModel(add);
                this.address.push(addressObj);
            }
        }));
    }
    /**
     * @param {?} userId
     * @param {?} payment
     * @param {?} cart
     * @param {?} cartTotal
     * @param {?} address
     * @param {?} deliveryOption
     * @return {?}
     */
    setOrderModelNew(userId, payment, cart, cartTotal, address, deliveryOption) {
        this.userId = userId;
        this.deliveryOption = deliveryOption;
        /** @type {?} */
        const paymentObj = new PaymentModel();
        if (payment) {
            paymentObj.setPaymentModel(payment);
            this.paymentMethod = paymentObj;
        }
        this.address = [];
        address.forEach((/**
         * @param {?} add
         * @return {?}
         */
        add => {
            /** @type {?} */
            const addressObj = new Address();
            if (add) {
                addressObj.setAddressModel(add);
                this.address.push(addressObj);
            }
        }));
        /** @type {?} */
        const cartObj = new Cart();
        cartObj.setCartModel(cart);
        this.cart = cartObj;
        this.totalPrice = cartTotal;
    }
    /**
     * @return {?}
     */
    validateOrderModel() {
        if (this.userId && this.totalPrice && this.deliveryOption && (this.address.length === 1 || this.address.length === 2)) {
            /** @type {?} */
            const paymentValid = this.paymentMethod.validatePaymentModel();
            /** @type {?} */
            const cartValid = this.cart.validateCartModel();
            //TODO validate delivery option
            this.address.forEach((/**
             * @param {?} add
             * @return {?}
             */
            add => {
                if (!add.validateAddressModel()) {
                    return false;
                }
            }));
            return (paymentValid && cartValid) ? true : false;
        }
        debug$1('could not validate order model');
        return false;
    }
}
if (false) {
    /** @type {?} */
    Order.prototype._id;
    /** @type {?} */
    Order.prototype.userId;
    /** @type {?} */
    Order.prototype.totalPrice;
    /** @type {?} */
    Order.prototype.paymentMethod;
    /** @type {?} */
    Order.prototype.deliveryOption;
    /** @type {?} */
    Order.prototype.address;
    /** @type {?} */
    Order.prototype.cart;
    /** @type {?} */
    Order.prototype.status;
    /** @type {?} */
    Order.prototype.isMarkedForDigitalConfirmationMailSent;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/actions/order.action.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * We can change the orders state using the actions.
 * This is action of post orders.
 * @type {?}
 */
const postOrder = createAction('[Order] post Order', props());
/**
 * This is action of post order when it return successfully.
 * @type {?}
 */
const onOrderPostedSuccessfully = createAction('[Order] Order posted successfully', props());
/**
 * This is action of post order when it failed.
 * @type {?}
 */
const onOrderPostingFailed = createAction('[Order]  Order posted failed');
/** @type {?} */
const sendDigitalConfirmEmails = createAction('[Order]  sendDigitalConfirmEmails', props());
/** @type {?} */
const onSendDigitalConfirmEmailsSuccessful = createAction('[Order]  sendDigitalConfirmEmails Successful');
/**
 * Dispatch to pass payload, you can create parametrizied Action in this way.
 * @record
 * @template T
 */
function ActionWithPayload() { }
if (false) {
    /** @type {?} */
    ActionWithPayload.prototype.payload;
}
/** @type {?} */
const getById = createAction('[Order] getById', props());
/** @type {?} */
const onByIdLoadedSuccessfully = createAction('[Order] ById loaded successfully', props());
/** @type {?} */
const onByIdLoadingFailed = createAction('[Order] ById loading failed', props());
/**
 * @record
 */
function ActionWithOrderId() { }
if (false) {
    /** @type {?} */
    ActionWithOrderId.prototype.orderId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/reducers/order.reducer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const featureKey = 'modesoOrderMicroservice';
/** @type {?} */
const adapter = createEntityAdapter({
    selectId: selectOrderId,
    sortComparer: sortById
});
/**
 * @param {?} a
 * @return {?}
 */
function selectOrderId(a) {
    return a._id;
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function sortById(a, b) {
    return a._id.localeCompare(b._id);
}
/**
 * @record
 */
function FeatureState() { }
if (false) {
    /** @type {?} */
    FeatureState.prototype.order;
    /** @type {?} */
    FeatureState.prototype.status;
    /** @type {?} */
    FeatureState.prototype.sendDigitalConfirmEmailsStatus;
}
/**
 * @record
 */
function AppState() { }
if (false) {
    /** @type {?} */
    AppState.prototype.modesoOrderMicroservice;
}
// State Declarations - END
// Selectors Declarations - START
/** @type {?} */
const selectFeature = (/**
 * @param {?} state
 * @return {?}
 */
(state) => state.modesoOrderMicroservice);
const ɵ0 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state;
/** @type {?} */
const selectFeatureOrder = createSelector(selectFeature, (ɵ0));
const ɵ1 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state.sendDigitalConfirmEmailsStatus;
/** @type {?} */
const sendDigitalConfirmEmailsStatusFeature = createSelector(selectFeature, (ɵ1));
const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
/** @type {?} */
const selectOrderEntities = createSelector(selectFeatureOrder, selectEntities);
/** @type {?} */
const selectOrderAllEntities = createSelector(selectFeatureOrder, selectAll);
const ɵ2 = /**
 * @param {?} entities
 * @param {?} props
 * @return {?}
 */
(entities, props) => {
    return entities[props.id];
};
/** @type {?} */
const selectOrderByID = createSelector(selectOrderEntities, (ɵ2));
// Selectors Declarations - END
// Reducer Declarations - START
/** @type {?} */
const initialEntityState = adapter.getInitialState();
/** @type {?} */
const initialState = Object.assign({}, initialEntityState, { order: new Order(), status: 'initial', sendDigitalConfirmEmailsStatus: false });
const ɵ3 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state)), ɵ4 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { order: action.payload, status: 'postedSuccessfully', sendDigitalConfirmEmailsStatus: false })), ɵ5 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state, { status: 'postedFaild' })), ɵ6 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ7 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => {
    return adapter.addOne(action.payload, Object.assign({}, state));
}, ɵ8 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ9 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state, { sendDigitalConfirmEmailsStatus: true })), ɵ10 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state, { sendDigitalConfirmEmailsStatus: true }));
/** @type {?} */
const orderReducer = createReducer(initialState, on(postOrder, (ɵ3)), on(onOrderPostedSuccessfully, (ɵ4)), on(onOrderPostingFailed, (ɵ5)), on(getById, (ɵ6)), on(onByIdLoadedSuccessfully, (ɵ7)), on(onByIdLoadingFailed, (ɵ8)), on(sendDigitalConfirmEmails, (ɵ9)), on(onSendDigitalConfirmEmailsSuccessful, (ɵ10)));
/**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
function reducer(state, action) {
    return orderReducer(state, action);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/order-checkout/order-checkout.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$2 = Debug('modeso:lidl-lib-order-fe:OrderCheckoutComponent');
class OrderCheckoutComponent {
    /**
     * @param {?} store
     */
    constructor(store) {
        this.store = store;
        this.orderState$ = this.store.pipe(select(selectFeatureOrder));
        this.order = new Order();
        this.refreshCartStore = false;
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        debug$2('submit order');
        // TODO - Order checkout component shouldn't do the checkout
        // The order must be executed, when the user clicks on "Submit Order"
        // Within the payment page
        // Then this component should just load the order data and display it.
        this.submit();
    }
    /**
     * @return {?}
     */
    submit() {
        this.constructOrderModel();
        if (this.validateOrderInputs() && this.order.validateOrderModel()) {
            this.store.dispatch(postOrder(this.order));
            this.checkSavedSuccessfully();
        }
        else {
            debug$2('could not validate order inputs');
            this.postedSuccessfully = false;
        }
    }
    /**
     * construct order model as {
     *  userId: string;
     *  totalPrice: number;
     *  paymentMethod: PaymentModel;
     *  address: Address[];
     *  cart: Cart;
     * }
     * @return {?}
     */
    constructOrderModel() {
        if (this.validateOrderInputs()) {
            this.order.setOrderModel(this.selectedPaymentOptionModel, this.cartModel, this.addressModels, this.selectedDeliveryOption);
        }
        else {
            debug$2('could not validate order inputs');
        }
    }
    /**
     *  check if the status in order store == 'postedSuccessfully' then order saved correctlly
     *  and change refreshCartStore to be true to dispatch action add new cart
     *
     *  else display order faild try again
     * @return {?}
     */
    checkSavedSuccessfully() {
        this.orderState$.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            if (data.status === 'postedSuccessfully') {
                this.postedSuccessfully = true;
                localStorage.removeItem('DeliveryAddressId');
                localStorage.removeItem('BillingAddressId');
                this.refreshCartStore = true;
            }
            else if (data.status === 'postedFaild') {
                this.postedSuccessfully = false;
            }
        }));
    }
    /**
     * check all compomnent inputs if defined or not
     * @return {?}
     */
    validateOrderInputs() {
        if (this.selectedPaymentOptionModel && this.cartModel.cart && this.addressModels && this.selectedDeliveryOption) {
            debug$2('selectedPaymentOptionModel:');
            debug$2(this.selectedPaymentOptionModel);
            debug$2('cart:');
            debug$2(this.cartModel.cart);
            debug$2('addressModels:');
            debug$2(this.addressModels);
            debug$2('selectedDeliveryOption:');
            debug$2(this.selectedDeliveryOption);
            debug$2('could not validate order inputs');
            return true;
        }
        else {
            debug$2('selectedPaymentOptionModel:');
            debug$2(this.selectedPaymentOptionModel);
            debug$2('cart:');
            debug$2(this.cartModel.cart);
            debug$2('addressModels:');
            debug$2(this.addressModels);
            debug$2('selectedDeliveryOption:');
            debug$2(this.selectedDeliveryOption);
            debug$2('could not validate order inputs');
            return false;
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptions.forEach((/**
         * @param {?} subscription
         * @return {?}
         */
        subscription => {
            subscription.unsubscribe();
        }));
    }
}
OrderCheckoutComponent.decorators = [
    { type: Component, args: [{
                selector: 'lidl-lib-order-fe-checkout',
                template: "  <div class=\"order-checkout-container\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <lidl-lib-order-fe-title\r\n          *ngIf=\"postedSuccessfully === true\"\r\n          [titleText]=\"'modeso_order_order-checkout_order-saved' | injectedText | async\">\r\n        </lidl-lib-order-fe-title>\r\n        <lidl-lib-order-fe-title\r\n          *ngIf=\"postedSuccessfully === false\"\r\n          [titleText]=\"'modeso_order_order-checkout_order-not-sent' | injectedText | async\">\r\n        </lidl-lib-order-fe-title>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-7\">\r\n        <lidl-lib-order-fe-sub-title\r\n          [subTitleText]=\"'modeso_order_order-checkout_thank-you' | injectedText | async\">\r\n        </lidl-lib-order-fe-sub-title>\r\n        <modeso-short-email-details\r\n          *ngIf=\"postedSuccessfully === true\"\r\n          [deliveryDate]=\"(orderState$ | async)?.order.cart.deliveryOption.deliveryDate\"\r\n          [orderId]=\"(orderState$ | async)?.order._id\">\r\n        </modeso-short-email-details>\r\n        <div class=\"row\">\r\n          <div [ngClass]=\"{ 'show-component': postedSuccessfully }\" class=\"col-lg-7 compact-component\">\r\n            <ng-content select=\"modeso-compact-address\"></ng-content>\r\n            <!-- <ng-content select=\"[address-content]\"></ng-content> -->\r\n          </div>\r\n          <div [ngClass]=\"{ 'show-component': postedSuccessfully }\" class=\"col-lg-5 compact-component\">\r\n            <ng-content select=\"modeso-checkout-payment-selected\"></ng-content>\r\n            <!-- <ng-content select=\"[payment-content]\"></ng-content> -->\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div [ngClass]=\"{ 'show-component': postedSuccessfully }\" class=\"col-lg-4 pull-right compact-component\">\r\n        <ng-content select=\"modeso-compact-cart\"></ng-content>\r\n        <!-- <ng-content select=\"[cart-content]\"></ng-content> -->\r\n      </div>\r\n\r\n    </div>\r\n\r\n    <div *ngIf=\"postedSuccessfully === false\" class=\"order-not-saved\">\r\n      {{ \"modeso_order_order-checkout_order-not-saved-successfully\" | injectedText | async }}\r\n    </div>\r\n\r\n    <div *ngIf=\"refreshCartStore === true\">\r\n      <ng-content select=\"modeso-refresh-cart-store\"></ng-content>\r\n      <!-- <ng-content select=\"[???-content]\"></ng-content> -->\r\n    </div>\r\n  </div>\r\n",
                styles: [".order-checkout-container .order-not-saved{background:#e29898;font-size:24px;border:1px solid #440303;padding:10px}.order-checkout-container .compact-component{visibility:hidden;height:0}.order-checkout-container .compact-component.show-component{visibility:visible;height:auto}"]
            }] }
];
/** @nocollapse */
OrderCheckoutComponent.ctorParameters = () => [
    { type: Store }
];
OrderCheckoutComponent.propDecorators = {
    cartModel: [{ type: Input }],
    addressModels: [{ type: Input }],
    selectedPaymentOptionModel: [{ type: Input }],
    selectedDeliveryOption: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    OrderCheckoutComponent.prototype.cartModel;
    /** @type {?} */
    OrderCheckoutComponent.prototype.addressModels;
    /** @type {?} */
    OrderCheckoutComponent.prototype.selectedPaymentOptionModel;
    /** @type {?} */
    OrderCheckoutComponent.prototype.selectedDeliveryOption;
    /** @type {?} */
    OrderCheckoutComponent.prototype.orderState$;
    /** @type {?} */
    OrderCheckoutComponent.prototype.order;
    /** @type {?} */
    OrderCheckoutComponent.prototype.postedSuccessfully;
    /** @type {?} */
    OrderCheckoutComponent.prototype.refreshCartStore;
    /** @type {?} */
    OrderCheckoutComponent.prototype.subscriptions;
    /**
     * @type {?}
     * @private
     */
    OrderCheckoutComponent.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/order-information/order-information.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$3 = Debug('modeso:lidl-lib-order-fe:OrderInformationComponent');
class OrderInformationComponent {
    /**
     * @param {?} store
     */
    constructor(store) {
        this.store = store;
        this.subscriptions = new Array();
        this.postedSuccessfully = false;
        this.orderState$ = this.store.pipe(select(selectFeatureOrder));
    }
    /**
     * @param {?} isOrderPostedSuccessfully
     * @return {?}
     */
    set setOrderPostedStatus(isOrderPostedSuccessfully) {
        this.postedSuccessfully = isOrderPostedSuccessfully;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.subscriptions.push(this.orderId$.subscribe((/**
         * @param {?} orderId
         * @return {?}
         */
        (orderId) => {
            //On change of the order Id request it from the store
            if (orderId === undefined) {
                debug$3('orderId is not defined');
                return;
            }
            else {
                this.order$ = this.store.pipe(select(selectOrderByID, { id: orderId }));
                this.store.dispatch(getById({ orderId }));
            }
        })));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptions.forEach((/**
         * @param {?} subscription
         * @return {?}
         */
        subscription => {
            subscription.unsubscribe();
        }));
    }
}
OrderInformationComponent.decorators = [
    { type: Component, args: [{
                selector: 'lidl-lib-order-fe-information',
                template: "<div class=\"order-information-container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-lg-12\">\r\n      <lidl-lib-order-fe-title [titleText]=\"'modeso_order_order-checkout_order-saved' | injectedText | async\">\r\n      </lidl-lib-order-fe-title>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-lg-7\">\r\n      <lidl-lib-order-fe-sub-title [subTitleText]=\"'modeso_order_order-checkout_thank-you' | injectedText | async\">\r\n      </lidl-lib-order-fe-sub-title>\r\n      <modeso-short-email-details\r\n      *ngIf=\"postedSuccessfully\"\r\n        [deliveryDate]=\"deliveryDate ? deliveryDate : (order$ | async)?.deliveryOption?.deliveryDate\"\r\n        [orderId]=\"(order$ | async)?._id\" [language]=\"language\">\r\n      </modeso-short-email-details>\r\n      <div class=\"row\">\r\n        <div [ngClass]=\"{ 'show-component': true }\" class=\"col-lg-7 compact-component\">\r\n          <ng-content select=\"[address-content]\"></ng-content>\r\n        </div>\r\n        <div [ngClass]=\"{ 'show-component': true }\" class=\"col-lg-5 compact-component\">\r\n\r\n          <ng-content select=\"[payment-content]\"></ng-content>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div [ngClass]=\"{ 'show-component': true }\" class=\"col-lg-4 pull-right compact-component\">\r\n      <ng-content select=\"[cart-content]\"></ng-content>\r\n    </div>\r\n  </div>\r\n</div>",
                styles: [".order-information-container .order-not-saved{background:#e29898;font-size:24px;border:1px solid #440303;padding:10px}.order-information-container .compact-component{visibility:hidden;height:0}.order-information-container .compact-component.show-component{visibility:visible;height:auto}"]
            }] }
];
/** @nocollapse */
OrderInformationComponent.ctorParameters = () => [
    { type: Store }
];
OrderInformationComponent.propDecorators = {
    orderId$: [{ type: Input }],
    deliveryDate: [{ type: Input }],
    language: [{ type: Input }],
    setOrderPostedStatus: [{ type: Input }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    OrderInformationComponent.prototype.subscriptions;
    /** @type {?} */
    OrderInformationComponent.prototype.orderId$;
    /** @type {?} */
    OrderInformationComponent.prototype.deliveryDate;
    /** @type {?} */
    OrderInformationComponent.prototype.language;
    /** @type {?} */
    OrderInformationComponent.prototype.postedSuccessfully;
    /** @type {?} */
    OrderInformationComponent.prototype.orderState$;
    /** @type {?} */
    OrderInformationComponent.prototype.order$;
    /**
     * @type {?}
     * @private
     */
    OrderInformationComponent.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/order.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function OrderResponse() { }
if (false) {
    /** @type {?} */
    OrderResponse.prototype.order;
}
class OrderService {
    /**
     *
     * @param {?} http
     * @param {?} config
     */
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.server = '';
        this.microserviceName = 'order';
        this.route = '/';
        this.detailRoute = ':id';
        this.sendConfirmDigital = 'sendConfirmDigitalEmails';
        this.server = config.apiGateway;
    }
    /**
     * service to post delivery address.
     * @param {?} data
     * @return {?}
     */
    postOrder(data) {
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}${this.route}`;
        return this.http.post(url, data);
    }
    /**
     * @param {?} id
     * @return {?}
     */
    getById(id) {
        /** @type {?} */
        const contentId = this.detailRoute.replace(':id', id);
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}${this.route}${contentId}`;
        return this.http.get(url);
    }
    /**
     * @param {?} orderId
     * @return {?}
     */
    sendDigitalConfirmEmailsByOrderId(orderId) {
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}${this.route}${this.sendConfirmDigital}${this.route}${orderId}`;
        return this.http.get(url);
    }
}
OrderService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
OrderService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [OrderConfigService,] }] }
];
/** @nocollapse */ OrderService.ngInjectableDef = ɵɵdefineInjectable({ factory: function OrderService_Factory() { return new OrderService(ɵɵinject(HttpClient), ɵɵinject(OrderConfigService)); }, token: OrderService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    OrderService.prototype.server;
    /**
     * @type {?}
     * @private
     */
    OrderService.prototype.microserviceName;
    /**
     * @type {?}
     * @private
     */
    OrderService.prototype.route;
    /**
     * @type {?}
     * @private
     */
    OrderService.prototype.detailRoute;
    /**
     * @type {?}
     * @private
     */
    OrderService.prototype.sendConfirmDigital;
    /**
     * @type {?}
     * @private
     */
    OrderService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    OrderService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/effects/order.effects.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$4 = Debug('modeso:lidl-lib-order-fe:OrderEffects');
class OrderEffects {
    /**
     *
     * @param {?} actions$
     * @param {?} service
     */
    constructor(actions$, service) {
        this.actions$ = actions$;
        this.service = service;
        /**
         * Effect of post delivery address.
         */
        this.postOrder$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(postOrder.type), mergeMap((/**
         * @param {?} payload
         * @return {?}
         */
        payload => {
            return this.service.postOrder(payload)
                .pipe(retry(1), map((/**
             * @param {?} response
             * @return {?}
             */
            response => (onOrderPostedSuccessfully({ payload: response.order })))), catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => of(onOrderPostingFailed()))));
        })))));
        this.loadById$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(getById.type), mergeMap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => {
            debug$4(`order should be loaded for ${action.orderId}`);
            return this.service.getById(action.orderId)
                .pipe(retry(1), tap((/**
             * @param {?} response
             * @return {?}
             */
            (response) => this.log(response))), map((/**
             * @param {?} response
             * @return {?}
             */
            response => (onByIdLoadedSuccessfully({ payload: response.order })))), catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => of(onByIdLoadingFailed({ payload: error })))));
        })))));
        this.sendDigitalConfirmEmails$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(sendDigitalConfirmEmails.type), mergeMap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => {
            return this.service.sendDigitalConfirmEmailsByOrderId(action.orderId)
                .pipe(map((/**
             * @return {?}
             */
            () => (onSendDigitalConfirmEmailsSuccessful()))), catchError((/**
             * @return {?}
             */
            () => EMPTY)));
        })))));
        this.errorOnLoadById$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onByIdLoadingFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleOnLoadAllContentErrors(action.payload))))), { dispatch: false });
    }
    /**
     * @param {?} error
     * @return {?}
     */
    handleOnLoadAllContentErrors(error) {
        debug$4(error);
        return error;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    log(data) {
        debug$4(data);
    }
}
OrderEffects.decorators = [
    { type: Injectable }
];
/** @nocollapse */
OrderEffects.ctorParameters = () => [
    { type: Actions },
    { type: OrderService }
];
if (false) {
    /**
     * Effect of post delivery address.
     * @type {?}
     */
    OrderEffects.prototype.postOrder$;
    /** @type {?} */
    OrderEffects.prototype.loadById$;
    /** @type {?} */
    OrderEffects.prototype.sendDigitalConfirmEmails$;
    /** @type {?} */
    OrderEffects.prototype.errorOnLoadById$;
    /**
     * @type {?}
     * @private
     */
    OrderEffects.prototype.actions$;
    /**
     * @type {?}
     * @private
     */
    OrderEffects.prototype.service;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/order.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class OrderModule {
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: OrderModule,
            providers: [
                OrderService,
                {
                    provide: OrderConfigService,
                    useValue: config
                },
            ]
        };
    }
}
OrderModule.decorators = [
    { type: NgModule, args: [{
                declarations: [OrderTitleComponent, ShortEmailDetailsComponent, OrderSubTitleComponent, OrderCheckoutComponent,
                    OrderInformationComponent],
                providers: [OrderService],
                imports: [
                    CommonModule,
                    StoreModule.forFeature(featureKey, reducer),
                    EffectsModule.forFeature([OrderEffects]),
                    InjectedTextFeautureModule
                ],
                exports: [OrderCheckoutComponent, OrderInformationComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/providers/orderStore.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$5 = Debug('modeso:lidl-lib-order-fe:OrderStoreProvider');
/** @type {?} */
const strings = [
    {
        'modeso_order_order-checkout_order-not-saved-successfully': 'Bestellung wurde nicht korrekt gespeichert. Bitte versuchen Sie es erneut.'
    },
    { 'modeso_order_order-checkout_order-not-sent': 'Bestellung konnte nicht abgesendet werden!' },
    { 'modeso_order_order-checkout_order-saved': 'Bestellung erfolgreich abgeschlossen' },
    { 'modeso_order_order-checkout_thank-you': 'Vielen Dank für Ihre Bestellung.' },
    { 'modeso_order_short-email-details_you-will-receive-email': 'In Kürze erhalten Sie eine Bestätigung per E-Mail.' },
    { 'modeso_order_short-email-details_order-referece-caption': 'Bestellreferenz:' },
    { 'modeso_order_short-email-details_order-delviery-date-caption': 'Voraussichtlicher Liefertermin:' },
];
class OrderStoreProvider {
    /**
     * @param {?} store
     * @param {?} injectedTextProvider
     */
    constructor(store, injectedTextProvider) {
        this.store = store;
        this.injectedTextProvider = injectedTextProvider;
        /** @type {?} */
        const defaultStrings = new Array();
        strings.forEach((/**
         * @param {?} element
         * @return {?}
         */
        (element) => {
            /** @type {?} */
            const x = new NamedString(Object.keys(element)[0], element[Object.keys(element)[0]]);
            defaultStrings.push(x);
        }));
        this.setInjectedText(defaultStrings);
    }
    /**
     * @private
     * @param {?} injectedText
     * @return {?}
     */
    setInjectedText(injectedText) {
        this.injectedTextProvider.setInjectedText(injectedText);
    }
    /**
     * createNewOrder
     * @param {?} order
     * @return {?}
     */
    createNewOrder(order) {
        debug$5('CREATE ORDER with...');
        debug$5(order);
        //TODO validate ORDER
        this.store.dispatch(postOrder(order));
    }
    // TODO add a method to access the store property by key, which generates an observable which can be used in a pipe
    // Is this the solution?
    /**
     * @return {?}
     */
    getNewOrder$() {
        return this.store.pipe(select(selectFeatureOrder), map((/**
         * @param {?} state
         * @return {?}
         */
        (state) => {
            debug$5('got order');
            debug$5(state);
            if (state.order) {
                return state.order;
            }
            else {
                debug$5('state does not contain an order');
                return undefined;
            }
        })));
    }
    /**
     * @param {?} orderId
     * @return {?}
     */
    getOrderById$(orderId) {
        return this.store.pipe(select(selectOrderByID, { id: orderId }));
    }
    /**
     * @param {?} orderId
     * @return {?}
     */
    sendDigitalConfirmEmails(orderId) {
        this.store.dispatch(sendDigitalConfirmEmails({ orderId }));
    }
}
OrderStoreProvider.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
OrderStoreProvider.ctorParameters = () => [
    { type: Store },
    { type: InjectedTextProvider }
];
/** @nocollapse */ OrderStoreProvider.ngInjectableDef = ɵɵdefineInjectable({ factory: function OrderStoreProvider_Factory() { return new OrderStoreProvider(ɵɵinject(Store), ɵɵinject(InjectedTextProvider)); }, token: OrderStoreProvider, providedIn: "root" });
if (false) {
    /** @type {?} */
    OrderStoreProvider.prototype.store;
    /**
     * @type {?}
     * @private
     */
    OrderStoreProvider.prototype.injectedTextProvider;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: modeso-giftcardshop-lib-order-fe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { DeliveryOption, Order, OrderConfigService, OrderModule, OrderService, OrderStoreProvider, OrderTitleComponent as ɵa, ShortEmailDetailsComponent as ɵb, OrderSubTitleComponent as ɵc, OrderCheckoutComponent as ɵd, featureKey as ɵe, initialState as ɵg, reducer as ɵh, OrderInformationComponent as ɵi, postOrder as ɵj, onOrderPostedSuccessfully as ɵk, onOrderPostingFailed as ɵl, sendDigitalConfirmEmails as ɵm, onSendDigitalConfirmEmailsSuccessful as ɵn, getById as ɵo, onByIdLoadedSuccessfully as ɵp, onByIdLoadingFailed as ɵq, OrderEffects as ɵr };
